// Mirror of farveladeland.com navigation structure
// Pruned to the essentials — removing overlapping/tiny sub-collections that
// only added noise (e.g. duplicate "Andre" buckets, room-by-room lamp splits,
// individual glass brands). The original site had 56 collections; we keep the
// ones a real customer would actually browse to.
//
// Naming: per shopkeeper preference, mushroom lamps are "Mushroom lamper" in
// Danish (English loanword), never "Svampelamper".

import type { DictKey } from "./i18n";

export type NavGroup = {
  /** i18n key for the group label */
  labelKey: DictKey;
  /** untranslated Italian sub-label (kept as-is in both locales) */
  italian: string;
  collections: Array<{ handle: string; labelDa: string; labelEn: string }>;
};

export const navGroups: NavGroup[] = [
  {
    labelKey: "nav.murano",
    italian: "Vetro di Murano",
    collections: [
      { handle: "murano-lamper", labelDa: "Alle Murano-lamper", labelEn: "All Murano lamps" },
      { handle: "murano-loftlamper", labelDa: "Loftlamper", labelEn: "Ceiling lamps" },
      { handle: "murano-lysekrone", labelDa: "Lysekroner", labelEn: "Chandeliers" },
      { handle: "murano-bordlamper", labelDa: "Bordlamper", labelEn: "Table lamps" },
      { handle: "murano-vaeglamper", labelDa: "Væglamper", labelEn: "Wall lamps" },
      { handle: "murano-mushroom-lampe", labelDa: "Mushroom lamper", labelEn: "Mushroom lamps" },
      { handle: "murano-vaser", labelDa: "Vaser", labelEn: "Vases" },
      { handle: "murano-glaskunst", labelDa: "Glaskunst", labelEn: "Glass art" },
      { handle: "murano-pa-udsalg", labelDa: "Murano på udsalg", labelEn: "Murano on sale" },
    ],
  },
  {
    labelKey: "nav.lamps",
    italian: "Lampade vintage",
    collections: [
      { handle: "vintage-lamper", labelDa: "Alle vintage-lamper", labelEn: "All vintage lamps" },
      { handle: "vintage-loftlamper", labelDa: "Loftlamper", labelEn: "Ceiling lamps" },
      { handle: "vintage-bordlamper", labelDa: "Bordlamper", labelEn: "Table lamps" },
      { handle: "vintage-vaeglamper", labelDa: "Væglamper", labelEn: "Wall lamps" },
    ],
  },
  {
    labelKey: "nav.tableware",
    italian: "Borddækning",
    collections: [
      { handle: "borddaekning", labelDa: "Al borddækning", labelEn: "All tableware" },
      { handle: "bryllupsservice", labelDa: "Bryllupsservice", labelEn: "Wedding service" },
      { handle: "sarreguemines-fajance-porcelaen", labelDa: "Sarreguemines", labelEn: "Sarreguemines" },
      { handle: "tallerkener", labelDa: "Tallerkener", labelEn: "Plates" },
      { handle: "fade", labelDa: "Fade", labelEn: "Platters" },
      { handle: "skaale", labelDa: "Skåle", labelEn: "Bowls" },
      { handle: "bestik", labelDa: "Bestik", labelEn: "Cutlery" },
      { handle: "kander", labelDa: "Kander", labelEn: "Pitchers" },
      { handle: "keramik-krus-og-kopper", labelDa: "Krus & kopper", labelEn: "Cups & mugs" },
    ],
  },
  {
    labelKey: "nav.glass",
    italian: "Vetro",
    collections: [
      { handle: "glas", labelDa: "Alt glas", labelEn: "All glass" },
      { handle: "vinglas", labelDa: "Vinglas", labelEn: "Wine glasses" },
      { handle: "vandglas", labelDa: "Vandglas", labelEn: "Water glasses" },
      { handle: "drinksglas", labelDa: "Drinksglas", labelEn: "Drinks glasses" },
      { handle: "glaskunst", labelDa: "Glaskunst", labelEn: "Glass art" },
      { handle: "glasskale", labelDa: "Glasskåle", labelEn: "Glass bowls" },
    ],
  },
  {
    labelKey: "nav.interior",
    italian: "Interno",
    collections: [
      { handle: "interior", labelDa: "Alt interiør", labelEn: "All interior" },
      { handle: "vaser", labelDa: "Vaser", labelEn: "Vases" },
      { handle: "krukke", labelDa: "Krukker", labelEn: "Jars" },
      { handle: "lysestager", labelDa: "Lysestager", labelEn: "Candle holders" },
      { handle: "vintage-spejle", labelDa: "Spejle", labelEn: "Mirrors" },
      { handle: "vaegpynt", labelDa: "Vægpynt", labelEn: "Wall decor" },
      { handle: "borde", labelDa: "Borde og småmøbler", labelEn: "Furniture & small pieces" },
    ],
  },
  {
    labelKey: "nav.sale",
    italian: "Saldi",
    collections: [
      { handle: "murano-pa-udsalg", labelDa: "Murano på udsalg", labelEn: "Murano on sale" },
      { handle: "abningstilbud", labelDa: "Åbningstilbud", labelEn: "Special offers" },
      { handle: "sidste-chance-farvelader", labelDa: "Sidste chance", labelEn: "Last chance" },
      { handle: "nyheder", labelDa: "Nyheder", labelEn: "New arrivals" },
    ],
  },
];
